import { render } from "./SimpleHeaderMobile.vue?vue&type=template&id=088d13fe&scoped=true"
import script from "./SimpleHeaderMobile.vue?vue&type=script&lang=js"
export * from "./SimpleHeaderMobile.vue?vue&type=script&lang=js"

import "./SimpleHeaderMobile.vue?vue&type=style&index=0&id=088d13fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088d13fe"]])

export default __exports__